module.exports = __webpack_public_path__ + "static/media/search-field.3bf82c21.svg";